import React, { useEffect, useState } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import styles from './styles.module.less';

export function Preview({ file, onRemove }) {
  const [image, setImage] = useState();

  useEffect(() => {
    let src = file.url;
    if (!src) {
      src = new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      }).then((src) => {
        setImage(src);
      });
    }
  }, []);

  if (image) {
    return (
      <div className={styles.previewWrap}>
        <img
          className={styles.preview}
          src={image}
          alt=""
        />
        <div
          onClick={onRemove}
          className={styles.remove}
          tabIndex={0}
          role="button"
        >
          <CloseOutlined />
        </div>
      </div>
    );
  }

  return null;
}
